import { COLORS } from '@elo-kit/constants/general.constants'
import { cleanupFonts } from 'utils/fonts.utils'

const { eloBlue, eloWhite } = COLORS
const LESSON_NAVIGATION_Z_INDEX = 21

// TODO: update with using createUseStyles
const mobileLessonsNavigationStyles = (theme) => ({
  pageNavigation: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '13px',
    paddingTop: '40px',
    fontFamily: cleanupFonts(theme.lesson.bannerFont) || 'Montserrat Reg',
    color: '#9e9e9e',
    '& i': {
      padding: '0 20px',
    },
  },
  pageNavigationActiveItem: {
    color: theme.linkColor || eloBlue,
    cursor: 'pointer',
  },
  mobileLessonsNavigation: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'fixed',
    bottom: 0,
    left: 0,
    backgroundColor: eloWhite,
    width: '100%',
    padding: '10px 20px',
    zIndex: LESSON_NAVIGATION_Z_INDEX,
    height: 60,
    boxShadow: '0 -2px 10px 0 rgba(0, 0, 0, 0.2)',
  },
  mobileLessonButtons: {
    display: 'flex',

    '& button:first-child': {
      marginRight: 25,
    },
  },
  noPaddings: {
    padding: '20px 0px',
  },
  button: {
    minWidth: '48px',
    minHeight: '48px',
    borderRadius: '6px',
    backgroundColor: theme.buttonColor || eloBlue,
    fontSize: '14px',
    fontFamily: cleanupFonts(theme.buttonFont) || 'Montserrat Medium',
    color: theme.buttonFontColor || eloWhite,
    border: 'none',
    padding: '0 16px',
    cursor: 'pointer',
    textTransform: 'unset',
    '& .fa-chevron-left': {
      fontSize: 22,
      paddingRight: 0,
    },
    '& .fa-chevron-right': {
      fontSize: 22,
      paddingLeft: 0,
    },
    '& .fa-bars': {
      fontSize: 24,
      paddingRight: 6,
    },
    '&:hover': {
      opacity: 0.8,
    },
    '&:active': {
      opacity: 0.6,
    },
  },
  outlineButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textTransform: 'uppercase',
    minWidth: '100px',
    minHeight: '48px',
    borderRadius: '6px',
    border: `solid 2px ${theme.buttonBorderColor || eloBlue}`,
    background: 'none',
    fontSize: '14px',
    fontFamily: cleanupFonts(theme.buttonFont) || 'Montserrat Medium',
    color: theme.buttonBorderColor || eloBlue,
    padding: '0 20px',
    cursor: 'pointer',
    '& .fa-chevron-left': {
      fontSize: 22,
      paddingRight: 0,
    },
    '& .fa-chevron-right': {
      fontSize: 22,
      paddingLeft: 0,
    },
    '& .fa-bars': {
      fontSize: 24,
      paddingRight: 6,
    },
    '&:hover': {
      opacity: 0.8,
    },
    '&:active': {
      opacity: 0.6,
    },
  },
})
export default mobileLessonsNavigationStyles
